"use client";

import { ArrowLeft, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ReactNode } from "react";

interface ScreenHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onSettings?: () => void;
  icon?: ReactNode;
  children?: ReactNode;
}

export function ScreenHeader({
  title,
  subtitle,
  onBack,
  onSettings,
  icon,
  children,
}: ScreenHeaderProps) {
  return (
    <header className="sticky top-0 z-10 bg-card shadow-[0_4px_16px_rgba(0,0,0,0.08)] dark:shadow-[0_4px_16px_rgba(0,0,0,0.4)]">
      <div className="px-4 py-3 flex items-center gap-3">
        {onBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="shrink-0 -ml-1 w-10 h-10 rounded-xl hover:bg-primary/10 hover:text-primary transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
        )}

        {icon && (
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shrink-0">
            {icon}
          </div>
        )}

        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-semibold text-foreground truncate">{title}</h1>
          {subtitle && (
            <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
          )}
        </div>

        {children}

        {onSettings && (
          <button
            type="button"
            onClick={onSettings}
            className="w-10 h-10 rounded-xl hover:bg-muted flex items-center justify-center transition-colors shrink-0"
          >
            <Settings className="w-5 h-5 text-muted-foreground" />
          </button>
        )}
      </div>
    </header>
  );
}
